import { Component } from '@angular/core';
import { MultiformatoService } from 'src/app/core/services/multiformato.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-multiformato',
  templateUrl: './multiformato.component.html'
})
export class MultiformatoComponent {

  isLinkMode = false;
  formato = '';
  tono = '';
  texto = '';
  link = '';
  mostrarModal = false;
  isLoading = false;
  resultado: string | null = null;

  constructor(private multiformatoService: MultiformatoService) {}

  generar() {

    Swal.fire({
      title: 'Generando...',
      text: 'Tu versión está en proceso.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const payload = {
      formato: this.formato,
      tono: this.tono,
      texto: this.isLinkMode ? this.link : this.texto,
      tipo: this.isLinkMode ? 'link' : 'texto'
    };

    this.multiformatoService.generarMultiformato(payload).subscribe({
      next: (res) => {
        Swal.close(); 

        this.resultado = res.data;
        this.mostrarModal = true;
      },

      error: (err) => {
        Swal.close(); 

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ocurrió un error al generar la versión.'
        });

        console.error(err);
      }
    });
  }

  cerrarModal(borrar: boolean = false) {
    this.mostrarModal = false;
  
    if (borrar) {
      this.resultado = null;
    }
  }  

  copiar() {
    if (!this.resultado) return;
  
    navigator.clipboard.writeText(this.resultado).then(() => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Copiado',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
      });
    });
  }
  

}
